module.exports = __webpack_public_path__ + "static/media/matching-score-rank-8.b3216e83.png";